import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const ResultHtml = ({ data, totalPax, requestBody, flights, loading, error, handleBookNow }) => {

  const [loadingFlightIndex, setLoadingFlightIndex] = useState(null);
  const [selectedFlight, setSelectedFlight] = useState(null);
  const [selectedFareIndex, setSelectedFareIndex] = useState(null);
  // -------------------------
  // Helper Functions
  // -------------------------
  const formatTime = (dateString) => {
    if (!dateString) return "—";
    const date = new Date(dateString);
    return date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
  };
  const navigate = useNavigate();
  const calcDuration = (start, end) => {
    if (!start || !end) return "—";
    const s = new Date(start);
    const e = new Date(end);
    const diff = Math.abs(e - s) / 1000 / 60;
    const h = Math.floor(diff / 60);
    const m = diff % 60;
    return `${h}h ${m}m`;
  };

  // -------------------------
  // Button Handlers

  const [selectedFare, setSelectedFare] = useState(null);


  const handleViewMoreFare = (flight) => {
    if (!flight) return;

    console.log("View More Fare", flight);
    setSelectedFlight(flight);
    setSelectedFare(null);

    setTimeout(() => {
      const offcanvas = document.getElementById("ViewMoreFare");
      if (offcanvas) {
        const bsOffcanvas = new window.bootstrap.Offcanvas(offcanvas);
        bsOffcanvas.show();
      }
    }, 50); // wait for React to update state
  };


  return (

    <div className="">
      <div className="row ruslt_sort mb-3">
        <div className="col-md-8 col-lg-8">
          <h3 className="destnation">
            {data.departureQuery?.split("(")[1]?.split(")")[0] || "DEL"}{" "}
            <i className="fa fa-arrow-right"></i>{" "}
            {data.arrivalQuery?.split("(")[1]?.split(")")[0] || "BOM"} |{" "}
            {totalPax} Total Pax | {data.onwardDate || "—"} | {requestBody.segments[0].preferredClass} ||
             <span style={{ color: "red",marginLeft:"10px" }}>Showing {flights.length} flights</span>
          </h3>
        </div>
        <div className="col-md-4 col-lg-4 text-end">
          <button
            className="modify_btn_sr"
            data-bs-toggle="modal"
            data-bs-target="#ModifyResult"
          >
            Modify Result <i className="fa fa-arrow-right"></i>
          </button>
        </div>
      </div>
      <div className="share_list" style={{ display: 'none' }}>
        <div className="d-flex-reco">
          <div className="fastest active">
            <img src="/assets/images/rupee.png" />
            <h4>Cheapest</h4>
            {/* <p><i className="fa fa-inr"></i> 230</p> */}
          </div>
          <div className="fastest">
            <img src="/assets/images/speed.png" />
            <h4>Fastest</h4>
            {/* <p><i className="fa fa-inr"></i> 04h 30m</p> */}
          </div>
          <div className="fastest">
            <img src="/assets/images/trolly.png" />
            <h4>Special Trip</h4>
            <p></p>
          </div>
        </div>
        <ul className="social_lst">
          <li className="share_by"><img src="/assets/Images/share.png" /> Share By :</li>
          <li>
            <a href="#"> <img src="/assets/Images/whatsapp.png" /> Whatsapp </a>
          </li>
          <li>
            <a href="#"> <img src="/assets/Images/email.png" />Email </a>
          </li>
          <li>
            <a href="#"> <img src="/assets/Images/view.png" />View </a>
          </li>
        </ul>
      </div>

      {/* Loader */}

     
      {error && <p style={{ color: "red" }}>{error}</p>}
      {!loading && flights.length === 0 && !error && <p>No flights found.</p>}

      {/* Flights list */}
      {flights.length > 0 && (
        <>

          <div className="results">
            {[...flights]
              .sort(
                (a, b) =>
                  Number(a.fares?.[0]?.totalFare || a.fare?.totalFare || 0) -
                  Number(b.fares?.[0]?.totalFare || b.fare?.totalFare || 0)
              )
              .map((f, idx) => {
                const seg = f.segments?.[0] || {};

                // Flight Info
                const airLineCode =
                  f.airLineCode || seg.airLineCode || "";
                const airLineName =
                  seg.airLineName || seg.airlineName || seg.carrierName || "Unknown Airline";
                const flightNumber =
                  f.flightNumber || seg.flightNumber || "";

                //  Locations
                const origin = f.origin || seg.origin || f.org || "";
                const destination =
                  f.destination || seg.destination || f.dest || "";

                //  Timing
                const departTime =
                  seg.departDateTime || f.departDateTime || "";
                const arrivalTime =
                  seg.arrivalDateTime || f.arrivalDateTime || "";
                const totalDuration =
                  seg.duration || f.duration || f.journeyDuration || calcDuration(departTime, arrivalTime);

                //  Fare Info
                const totalFare =
                  Number(f.fares?.[0]?.totalFare || f.fare?.totalFare || 0);
                const isRefundable =
                  f.fares?.[0]?.isRefundable ?? false;


                // const [loadingFlightIndex, setLoadingFlightIndex] = useState(null);
                //  Stops
                const stops = f.stops ?? f.totalStops ?? 0;

                return (
                  <div key={idx} className="result_repeat mb-2">
                    <div className="row">
                      {/* Left Section */}
                      <div className="col-md-8 col-lg-8">
                        <div className="row">
                          <div className="col-md-4 col-lg-4">
                            <div className="row">
                              <div className="col-md-4 col-lg-4">
                                <div className="flight_img">
                                  <div>
                                    <img
                                      src={`/assets/images/Flight_Images/${f.segments[0].airLineCode}.gif`}
                                      alt={f.segments[0].airLineName}
                                      width="50"
                                    />
                                  </div>

                                </div>
                              </div>
                              <div className="col-md-8 col-lg-8">
                                <figure className="flight_sect">
                                  <span>{airLineCode}-{flightNumber}</span>
                                  <span className="airlineImage">{airLineName} </span>
                                  <span
                                    className="onTime"
                                    style={{ display: f.otp ? "inline" : "none" }}
                                  >
                                    {f.otp} On-Time
                                  </span>
                                </figure>
                              </div>
                            </div>
                          </div>

                          <div className="col-md-8 col-lg-8 border-left-right">
                            <div className="row">
                              <div className="col-md-4 col-lg-4">
                                <div className="timer">
                                  <h4>{formatTime(departTime)}</h4>
                                  <p>{origin}</p>
                                </div>
                              </div>
                              <div className="col-md-3 col-lg-3">
                                <div className="deruation">
                                  <p>{totalDuration}</p>
                                  <div className="bordr_top">
                                    <i className="fa fa-plane"></i>
                                  </div>
                                  <p className="stops">{stops} stop</p>
                                </div>
                              </div>
                              <div className="col-md-4 col-lg-4 offset-1">
                                <div className="timer">
                                  <h4>{formatTime(arrivalTime)}</h4>
                                  <p>{destination}</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Right Price Section */}
                      <div className="col-md-4 col-lg-4">
                        <div className="price_view">
                          <div className="row">
                            <div className="col-md-7 col-lg-7">
                              <div className="flight_charge">
                                <i className="fa fa-inr"></i>{Number(totalFare || 0).toLocaleString()}
                              </div>
                              <button
                                className="view_more"
                                onClick={() => handleViewMoreFare(f)}
                              >
                                View More Fare
                              </button>
                            </div>
                            <div className="col-md-5 col-lg-5">
                              <button className="book_now_fly"
                                onClick={() => handleBookNow(f, idx)}
                                disabled={loadingFlightIndex === idx}
                              >
                                {loadingFlightIndex === idx ? "Checking Price..." : "Book Now"}
                              </button>

                              {/* <a href="/flight" className="Send_Request">
                                Send Request
                              </a> */}
                            </div>
                          </div>
                        </div>
                      </div>
                      {f.segments.map((segment, index) => (
                        <div key={index}>

                        </div>
                      ))}
                      {/* Footer Info */}
                      <div className="col-md-12 col-lg-12">
                        <ul className="list_service">
                          <li>
                            <div className="d-flex">
                              <div className="equipmentType">
                                <i className="fa-solid fa-fan"></i>
                                <span>{f.segments[0].equipmentType}</span>
                              </div>

                              <div className="equipmentType">
                                <img
                                  className="seats"
                                  src="/assets/images/seat.png"
                                  alt="seat"
                                />
                                <span>{f.segments[0].availableSeats} Seats</span>
                              </div>
                            </div>

                          </li>
                          <li className="refundable">


                            {isRefundable ? (
                              <span style={{ color: "green" }}><i className="fa fa-inr" style={{ color: "green" }}></i> Refundable</span>
                            ) : (
                              <span style={{ color: "red" }}><i className="fa fa-inr" style={{ color: "red" }}></i> Non-Refundable</span>
                            )}

                          </li>
                          <li className="view_on">

                            <a
                              className="flight_details"
                              data-bs-toggle="offcanvas"
                              data-bs-target="#FlightDetails"
                              onClick={() => setSelectedFlight(f)}
                            >
                              <i className="fa fa-plane"></i> Flight Details
                            </a>
                          </li>
                        </ul>
                        {/* <p className="required_visa">
                          Dear, Don't need visa:{" "}
                          <span>{"Visa on Arrival"}</span>
                        </p> */}
                      </div>
                    </div>




                  </div>

                );
              })}
          </div>
        </>
      )}
 {loading && <p className="text-center"><span className="loader"></span></p>}
      <div
        className="offcanvas offcanvas-end"
        id="ViewMoreFare"
        tabIndex="-1"
        aria-labelledby="ViewMoreFareLabel"
      >
        <div className="offcanvas-header">
          <h1 className="offcanvas-title" id="ViewMoreFareLabel">
            More Fare Options Available
          </h1>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          ></button>
        </div>

        <div className="offcanvas-body">
          {selectedFlight ? (
            <>
              <div className="vie_fare d-flex align-items-center gap-3">
                <div className="from_to">
                  <img
                    alt={selectedFlight.segments?.[0]?.airLineName || "airline"}
                    src={`/assets/images/Flight_Images/${selectedFlight.segments?.[0]?.airLineCode}.gif`}
                  />
                </div>
                <div className="flight_time">
                  <span>
                    <strong>
                      {selectedFlight.origin} ({selectedFlight.segments?.[0]?.departAirportCode}) →{" "}
                      {selectedFlight.destination} ({selectedFlight.segments?.[0]?.arrivalAirportCode})
                    </strong>
                  </span>
                  <span>
                    <strong>{selectedFlight.segments?.[0]?.airLineName}</strong>
                  </span>
                  <span>
                    <strong>
                      {new Date(
                        selectedFlight.segments?.[0]?.departDateTime
                      ).toDateString()}
                    </strong>
                  </span>
                  <span>
                    Departure at:{" "}
                    <strong>{formatTime(selectedFlight.segments?.[0]?.departDateTime)}</strong>
                  </span>
                  <span>
                    Arrival at:{" "}
                    <strong>{formatTime(selectedFlight.segments?.[0]?.arrivalDateTime)}</strong>
                  </span>
                </div>
              </div>

              <div className="d-flex flex-wrap mt-3">
                {selectedFlight.fares?.length > 0 ? (
                  selectedFlight.fares.map((fare, index) => (
                    <div key={index} className="Select_new_fare repeat_section">
                      <h5>{fare.fareType || "Standard Fare"}</h5>
                      <h3>
                        <i className="fa fa-inr"></i>{" "}
                        {fare.totalFare?.toLocaleString("en-IN")}
                      </h3>

                      <div className="riepet d-flex flex-wrap justify-content-between">

                        <div className="baggage">
                          <h4>
                            <i className="fa fa-suitcase-rolling"></i> Fare Inclusions
                          </h4>

                          <ul>
                            {fare.fareInclusions && fare.fareInclusions.length > 0 ? (
                              fare.fareInclusions.map((item, i) => (
                                <li key={i}> {item}</li>
                              ))
                            ) : (
                              <li>No fare inclusions available</li>
                            )}
                          </ul>
                        </div>



                      </div>

                      <div className="d-flex-btn d-flex justify-content-between align-items-center mt-2">
                        <p
                          className="refun"
                          style={{
                            color: fare.isRefundable ? "green" : "red",
                            fontWeight: "500",
                          }}
                        >
                          {fare.isRefundable ? "Refundable" : "Non Refundable"}
                        </p>
                        <button
                          className="btn btn-primary btn-sm"
                          onClick={() => {
                            setSelectedFare(fare);
                            setSelectedFareIndex(index); // <-- IMPORTANT
                          }}
                        >
                          Select
                        </button>
                      </div>
                    </div>
                  ))
                ) : (
                  <p>No fare options available</p>
                )}
              </div>
            </>
          ) : (
            <p>No flight selected</p>
          )}
        </div>

        {selectedFare && (
          <div className="total_amount border-top p-3">
            <p className="Grand">Grand Total</p>
            <h1>
              <i className="fa fa-inr"></i>{" "}
              {selectedFare?.totalFare?.toLocaleString("en-IN")}
            </h1>

            <button
              className="btn btn-primary"
              onClick={() => handleBookNow(selectedFlight, selectedFareIndex)}
              disabled={loadingFlightIndex === selectedFareIndex}
            >
              {loadingFlightIndex === selectedFareIndex ? "Checking ..." : "Book Now"}
            </button>

          </div>
        )}
      </div>


      <div className="offcanvas offcanvas-end" tabIndex="-1" id="FlightDetails" aria-labelledby="FlightDetailsLabel">
        <div className="offcanvas-header">
          <h1 className="offcanvas-title">Flight Details</h1>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          ></button>
        </div>

        <div className="offcanvas-body">
          {selectedFlight ? (
            <>

              <ul class="nav nav-tabs nav-line-tabs nav-line-tabs-2x mb-5 fs-6">
                <li class="nav-item"><a class="nav-link active" data-bs-toggle="tab" href="#kt_tab_pane_4">Flight Information</a></li>
                <li class="nav-item"><a class="nav-link" data-bs-toggle="tab" href="#kt_tab_pane_5">Fare Details &amp; Rules</a></li>
                <li class="nav-item"><a class="nav-link" data-bs-toggle="tab" href="#kt_tab_pane_6">Baggage Information</a></li>
                <li class="nav-item"><a class="nav-link" data-bs-toggle="tab" href="#kt_tab_pane_7">Cancellation &amp; Change Rule</a></li>
              </ul>
              <div class="tab-content" id="myTabContent">
                <div class="tab-pane fade show active" id="kt_tab_pane_4" role="tabpanel">
                  <h3 class="destnation"> {selectedFlight.origin} ({selectedFlight.segments?.[0]?.departAirportCode}) <i class="fa fa-arrow-right"></i>
                    {selectedFlight.destination} ({selectedFlight.segments?.[0]?.arrivalAirportCode})</h3>
                  <ul class="rlst_flight_detls">
                    {/* <li>{selectedFlight.tripType === 1 ? "One Way" : "Round Trip"}</li> */}
                    <li>{selectedFlight.selClass || "Economy"}</li>
                    <li>{selectedFlight.adult + selectedFlight.child + selectedFlight.infant} Traveller(s)</li>
                    <li>{new Date(selectedFlight.segments?.[0]?.departDateTime).toDateString()}</li>
                  </ul>
                  <div class="d-flex flgt_dlts">
                    <div class="img_img_flight">
                      <img className="flight_i" src={`/assets/images/Flight_Images/${selectedFlight.segments?.[0]?.airLineCode}.gif`} alt={selectedFlight.segments?.[0]?.airLineName} />
                    </div>
                    <div class="text_img_t">
                      <h5>{new Date(selectedFlight.segments?.[0]?.departDateTime).toDateString()}</h5>
                      <p>{selectedFlight.origin} - {selectedFlight.destination} | {selectedFlight.segments?.[0]?.duration || "Duration N/A"} </p>
                    </div>
                  </div>
                  <div class="d-flex-v">
                    <div class="d-flex-v-f">
                      <h4>{formatTime(selectedFlight.segments?.[0]?.departDateTime)}</h4>
                    </div>
                    <div class="d-flex-v-m"><span class="zero"></span></div>
                    <div class="d-flex-v-l">
                      <h4>{selectedFlight.origin}</h4>
                      <p>  {selectedFlight.segments?.[0]?.departAirportName}
                        {selectedFlight.segments?.[0]?.departTerminal
                          ? `, Terminal ${selectedFlight.segments?.[0]?.departTerminal}`
                          : ""}</p>
                    </div>
                  </div>
                  <div className="d-flex-v time_to_frm">
                    <div className="d-flex-v-l m-autto">
                      {selectedFlight.segments?.map((seg, index) => (
                        <div key={index} className="d-flex mb-3 align-items-center">

                          {/* DATE + TIME FOR EACH SEGMENT */}
                          <div className="d-flex-v-f m-autto me-3">
                            <h6>{new Date(seg.departDateTime).toDateString()}</h6>
                            <p className="mb-0">
                              {new Date(seg.departDateTime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                              {"  "}
                              ➜
                              {"  "}
                              {new Date(seg.arrivalDateTime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                            </p>
                          </div>
                          <div className="d-flex-v-m fhty_rg">
                            <i className="fa fa-plane flights"></i>
                          </div>
                          {/* AIRLINE LOGO + NAME */}
                          <div className="d-flex">
                            <div className="img_flt">
                              <img
                                className="flight_i"
                                src={`/assets/images/Flight_Images/${seg.airLineCode}.gif`}
                                alt={seg.airLineName}
                              />
                            </div>

                            <div className="flt_name ms-2">
                              {seg.airLineName} - {seg.airLineCode}-{seg.flightNumber}

                              {/* Arrow between segments */}
                              {index < selectedFlight.segments.length - 1 && (
                                <span className="mx-2">
                                  <i className="fa fa-arrow-right"></i>
                                </span>
                              )}
                            </div>
                          </div>

                        </div>
                      ))}
                    </div>

                  </div>

                  <div class="d-flex-v">
                    <div class="d-flex-v-f"><h4>{formatTime(selectedFlight.segments?.[0]?.arrivalDateTime)}</h4></div>
                    <div class="d-flex-v-m"><span class="zero"></span></div>
                    <div class="d-flex-v-l">
                      <h4>{selectedFlight.destination}</h4>
                      <p>  {selectedFlight.segments?.[0]?.arrivalAirportName}
                        {selectedFlight.segments?.[0]?.arrivalTerminal
                          ? `, Terminal ${selectedFlight.segments?.[0]?.arrivalTerminal}`
                          : ""}</p>
                    </div>
                  </div>


                </div>
                <div class="tab-pane fade" id="kt_tab_pane_5" role="tabpanel">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="fareRuls">
                        <table class="table table-bordered">
                          <tbody>
                            <tr>
                              <th>
                                Time Frame to cancel<br />
                                <span>Before scheduled departure time</span>
                              </th>
                              <th>
                                Airline Fees <br />
                                <span>per passenger</span>
                              </th>

                            </tr>
                            <tr>
                              <td>Cancel Before 72 hours of departure time.</td>
                              <td>3,999</td>

                            </tr>
                            <tr>
                              <td>Cancel within 72 hours &amp; before 24 hours of departure time.</td>
                              <td>3,999</td>

                            </tr>

                          </tbody>
                        </table>
                      </div>
                      <div class="fareRuls">
                        <table class="table table-bordered">
                          <tbody>
                            <tr>
                              <th>
                                Time Frame to reschedule <br />
                                <span>Before scheduled departure time</span>
                              </th>
                              <th>
                                Airline Fees <br />
                                <span>per passenger</span>
                              </th>

                            </tr>
                            <tr>
                              <td>Reschedule before 72 hours of departure time.</td>
                              <td>2,999</td>

                            </tr>
                            <tr>
                              <td>Reschedule within 72 hours &amp; before 24 hours of departure time.</td>
                              <td>2,999</td>

                            </tr>

                          </tbody>
                        </table>
                      </div>
                      <div class="col-md-12 col-lg-12">
                        <h4>Terms &amp; Conditions</h4>
                        <ul>
                          <li>Total Rescheduling Charges Airlines Rescheduling fees Fare Difference if applicable.</li>
                          <li>The airline cancel reschedule fees is indicative and can be changed without any prior notice by the airlines..</li>
                          <li>Berry Journeys does not guarantee the accuracy of cancel reschedule fees.</li>
                          <li>Partial cancellation is not allowed on the flight tickets which are book under special round trip discounted fares.</li>
                          <li>Airlines doesnt allow any additional baggage allowance for any infant added in the booking</li>
                          <li>In certain situations of restricted cases, no amendments and cancellation is allowed</li>
                          <li>Airlines cancel reschedule should be reconfirmed before requesting for a cancellation or amendment</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="tab-pane fade" id="kt_tab_pane_6" role="tabpanel">
                  <table class="table table-bordered">
                    <tbody>
                      <tr>
                        <th>Airline</th>
                        <th>Check-in Baggage</th>
                        <th>Cabin Baggage</th>
                      </tr>
                      <tr>
                        <td>
                          <img className="flight_name" src={`/assets/images/Flight_Images/${selectedFlight.segments?.[0]?.airLineCode}.gif`} alt={selectedFlight.segments?.[0]?.airLineName} />
                          <p class="plane_name">{selectedFlight.segments?.[0]?.airLineName}</p>
                          <p class="code_plne">{selectedFlight.segments?.[0]?.airLineCode}-
                            {selectedFlight.segments?.[0]?.flightNumber}</p>

                        </td>
                        <td>15kgs</td>
                        <td>7kgs</td>
                      </tr>
                      <tr>
                        <td>
                          <img className="flight_name" src={`/assets/images/Flight_Images/${selectedFlight.segments?.[0]?.airLineCode}.gif`} alt={selectedFlight.segments?.[0]?.airLineName} />
                          <p class="plane_name">{selectedFlight.segments?.[0]?.airLineName}</p>
                          <p class="code_plne">{selectedFlight.segments?.[0]?.airLineCode}-
                            {selectedFlight.segments?.[0]?.flightNumber}</p>
                        </td>
                        <td>15kgs</td>
                        <td>7kgs</td>
                      </tr>
                      <tr>
                        <td colspan="3">
                          <div class="termsbagg">
                            <ul>
                              <li>Baggage information mentioned above is obtained from airline's reservation system, Berry Journeys does not guarantee the accuracy of this information.</li>
                              <li>The baggage allowance may vary according to stop-overs, connecting flights. changes in airline rules. etc.</li>
                            </ul>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="tab-pane fade" id="kt_tab_pane_7" role="tabpanel">
                  <div class="fareRuls">
                    <table class="table table-bordered">
                      <tbody>
                        <tr>
                          <th>
                            Time Frame to cancel <br />
                            <span>Before scheduled departure time</span>
                          </th>
                          <th>
                            Airline Fees <br />
                            <span>per passenger</span>
                          </th>

                        </tr>
                        <tr>
                          <td>Cancel Before 72 hours of departure time.</td>
                          <td>3,999</td>
                        </tr>
                        <tr>
                          <td>Cancel within 72 hours &amp; before 24 hours of departure time.</td>
                          <td>3,999</td>
                        </tr>
                        <tr>
                          <td>Cancel within 24 hours &amp; before 4 hours of departure time.</td>
                          <td>4,999</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="fareRuls">
                    <table class="table table-bordered">
                      <tbody>
                        <tr>
                          <th>
                            Time Frame to reschedule <br />
                            <span>Before scheduled departure time</span>
                          </th>
                          <th>
                            Airline Fees <br />
                            <span>per passenger</span>
                          </th>

                        </tr>
                        <tr>
                          <td>Reschedule before 72 hours of departure time.</td>
                          <td>2,999</td>
                        </tr>
                        <tr>
                          <td>Reschedule within 72 hours &amp; before 24 hours of departure time.</td>
                          <td>2,999</td>
                        </tr>
                        <tr>
                          <td>Reschedule within 24 hours &amp; before 4 hours of departure time.</td>
                          <td>2,999</td>
                        </tr>
                        <tr></tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <div class="total_amount">
                <p class="Grand">Grand Total</p>
                <h1>
                  <i className="fa fa-inr"></i>{" "}
                  {Number(selectedFlight.fares?.[0]?.totalFare || 0).toLocaleString()}
                </h1>
                {/* <button class="btn btn-primary">Book Now</button> */}
                <button
                  className="btn btn-primary"
                  onClick={() => handleBookNow(selectedFlight, selectedFareIndex)}
                  disabled={loadingFlightIndex !== null && loadingFlightIndex === selectedFareIndex}
                >
                  {loadingFlightIndex !== null && loadingFlightIndex === selectedFareIndex
                    ? "CheckingPrice..."
                    : "Book Now"}
                </button>

              </div>
            </>
          ) : (
            <p>No flight selected</p>
          )}
        </div>
      </div>


    </div>
  );
};

export default ResultHtml;
